/**
 * This file is part of "Zona franca"
 * Copyright (c) 2022
 * Zona franca
 * All rights reserved
 *
 * @author Turiano Romero <https://bitbucket.org/rome9603/ | tromero@technisupport.com>
 * @version 2.0
 */

import { authTypes } from "redux/types";

const loginAction = (payload) => {
  return {
    type: authTypes.login,
    payload
  };
};

const logoutAction = () => {
  return {
    type: authTypes.logout
  };
};

export const getAuthData = (state) => state?.auth;


export { loginAction, logoutAction };
